import React, {useEffect, useState} from "react";
import {CardContent, CardHeader, Button, Alert, Typography} from "@mui/material";
import {useDispatch} from "react-redux";
import {deleteDepartment, fetchDepartment} from "../../index";
import DialogActions from "@mui/material/DialogActions";
import {setModal} from "../../../../Common/App";
import {DialogCard} from "../../../../../Components/Cards/DialogCard";
import {Loader} from "../../../../../Components";
import { useNavigate } from "react-router-dom";

export const DeleteDepartmentModal = ({id}) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [, setErrors] = useState({});
    const [message, setMessage] = useState("");
    const [status, setStatus] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [department, setDepartment] = useState(null);
    const [isFetching, setIsFetching] = useState(true);

    useEffect(() => {
        const fetchDept = async () => {
            setIsFetching(true);
            const columns = ['id', 'department_name', 'is_parking'];
            await fetchDepartment({dispatch, filters:{id, with:['users'], withCount:['users'], columns}}).then((res) => {
                if(res.success && res.data) {
                    setDepartment(res.data);
                }
                setIsFetching(false);
            });
        };
        if(id) {
            fetchDept();
        }
    }, [id, dispatch]);

    const handleSubmit = async () => {
        setIsLoading(true);
        await deleteDepartment({dispatch, filters:{id}}).then((res) => {
            if(res.success) {
                dispatch(setModal({component:null, open:false}));
                navigate("/departments");
            }
            setIsLoading(false);
            setErrors(res.errors);
            setMessage(res.message);
            setStatus(res.status);
        });
    };

    const userCount = department?.users_count || department?.users?.length || 0;
    const isParked = department?.is_parking;

    return(
        <DialogCard>
            <CardHeader
                title={"Delete Department"}
                avatar={<Loader isLoading={isLoading || isFetching} type={"linear"}/>}
            />
            <CardContent sx={{ p: 2, pt:2 }}>
                {isFetching ? (
                    <Typography variant="body2" color="text.secondary">
                        Loading department details...
                    </Typography>
                ) : (
                    <>
                        {isParked ? (
                            <Alert severity="error" sx={{ mb: 2 }}>
                                Cannot delete the Parked Department. This department is used for unassigned employees.
                            </Alert>
                        ) : (
                            <>
                                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                                    You are about to delete the department <strong>"{department?.department_name}"</strong>.
                                    {userCount > 0 && (
                                        <> This department has <strong>{userCount} employee{userCount !== 1 ? 's' : ''}</strong> assigned to it.</>
                                    )}
                                </Typography>
                                <Alert severity="info" sx={{ mb: 2 }}>
                                    {userCount > 0 
                                        ? `All ${userCount} employee${userCount !== 1 ? 's' : ''} will be automatically moved to the Parked Department (No Department).`
                                        : 'This department has no employees assigned.'
                                    }
                                </Alert>
                            </>
                        )}
                    </>
                )}
                {message && (
                    <Alert severity={status === 'error' ? 'error' : 'info'} sx={{ mt: 2 }}>
                        {message}
                    </Alert>
                )}
            </CardContent>
            <DialogActions sx={{ mb: 2, mr: 2, justifyContent: 'flex-end' }}>
                <Button onClick={() => dispatch(setModal({component:null, open:false}))}>Cancel</Button>
                <Button 
                    disabled={isLoading || isFetching || isParked} 
                    variant="contained" 
                    color={'error'} 
                    onClick={handleSubmit}
                >
                    Delete
                </Button>
            </DialogActions>
        </DialogCard>
    )
}